import { Controller } from '@hotwired/stimulus';

const POLL_INTERVAL_MS = 5000;
const MAX_POLL_MS = 180000;

export default class extends Controller {
  static targets = ['pending', 'fallback'];

  static values = { url: String };

  connect() {
    this.startedAt = Date.now();
    this.schedule();
  }

  disconnect() {
    this.clearTimer();
  }

  fallbackTargetConnected(element) {
    element.classList.toggle('d-none', this.polling === true);
  }

  schedule() {
    this.clearTimer();
    if (!this.hasPendingTarget || Date.now() - this.startedAt >= MAX_POLL_MS) {
      this.stop();
      return;
    }
    this.setPolling(true);
    this.timer = setTimeout(() => this.refresh(), POLL_INTERVAL_MS);
  }

  refresh() {
    this.timer = null;
    if (!this.element.src) this.element.src = this.urlValue;
    Promise.resolve(this.element.reload())
      .catch(() => {})
      .finally(() => {
        if (!this.timer && !this.stopped) this.schedule();
      });
  }

  giveUp(event) {
    event.preventDefault();
    this.stop();
  }

  stop() {
    this.stopped = true;
    this.clearTimer();
    this.setPolling(false);
  }

  setPolling(polling) {
    this.polling = polling;
    this.fallbackTargets.forEach((element) => element.classList.toggle('d-none', polling));
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
